import assert from 'minimalistic-assert';
const validateSerialized = (serialized) => {
    return typeof serialized === 'string';
};
const serialize = (deserialized) => {
    assert(Buffer.isBuffer(deserialized), `publicKey was not a Buffer`);
    return deserialized.toString('hex');
};
const deserialize = (serialized) => {
    assert(serialized, `publicKey was not a string`);
    return Buffer.from(serialized, 'hex');
};
const defaultExport = {
    validateSerialized,
    serialize,
    deserialize,
};
export default defaultExport;
